import { AlertWindow } from '@sunwebgroup/uds-ui/alert-window'
import { Button } from '@sunwebgroup/uds-ui/button'
import { useIntl } from '@/intl'
import { useBookingDetailsActions } from '@/scopes/account/booking-details/infrastructure/dependencies/dependencies'

export function BookingDeletedAlertContent() {
  const { formatMessage } = useIntl()
  const { bookingDeletionAcknowledged } = useBookingDetailsActions()

  return (
    <AlertWindow.Content
      text={formatMessage({ id: 'booking_details_manage_booking_delete_window_success_title' })}
      supportingText={formatMessage({ id: 'booking_details_manage_booking_delete_window_success_text' })}
      renderPrimaryActionSlot={() => (
        <Button
          onClick={bookingDeletionAcknowledged}
          ariaLabel={formatMessage({ id: 'booking_details_manage_booking_delete_window_success_button_label' })}
        >
          {formatMessage({ id: 'booking_details_manage_booking_delete_window_success_button_label' })}
        </Button>
      )}
    />
  )
}
